import { useParams } from '@tanstack/react-router'

import { AttemptReview } from '../features/students/AttemptReview.js'

/**
 * Reads the attempt id off the route and hands it to the review.
 *
 * Split for the same reason `AttemptScreen` is: `useParams({ from })` needs
 * the real route to exist, and reproducing the tutor tree in every test of
 * the review buys nothing.
 */
export function AttemptReviewScreen() {
  const { attemptId } = useParams({ from: '/$language/tutor/attempts/$attemptId' })
  return <AttemptReview attemptId={attemptId} />
}
